import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`} role="banner">
      <div className="header-container">
        <Link to="/" className="logo-container" onClick={() => setMenuOpen(false)} aria-label="CodeViaje Home">
          <img src="/Logo.png" alt="CodeViaje Logo" className="logo" />
          <div className="logo-text">
            <h1>CODEVIAJE</h1>
            <span>Innovative IT Solutions</span>
          </div>
        </Link>
        
        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`} role="navigation" aria-label="Main navigation">
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} aria-current={location.pathname === '/' ? 'page' : undefined}>
            Home
          </Link>
          <Link to="/Projects" className={`nav-link ${location.pathname === '/Projects' ? 'active' : ''}`} aria-current={location.pathname === '/Projects' ? 'page' : undefined}>
            Projects
          </Link>
          <Link to="/Contact" className={`nav-link ${location.pathname === '/Contact' ? 'active' : ''}`} aria-current={location.pathname === '/Contact' ? 'page' : undefined}>
            Contact
          </Link>
        </nav>
        
        <button 
          className="menu-toggle" 
          onClick={toggleMenu} 
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="main-navigation"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
}

export default Header;
